/**
 * Updates cached user after profile API save. Reloads so header/sidebar pick up changes.
 * @param {object} user - User object from API (must include id, name, email)
 */
export function persistUserAndRefresh(user) {
  if (!user || typeof user !== 'object') return
  localStorage.setItem('user', JSON.stringify(user))
  window.location.reload()
}